import {  IntervalObservable  } from '/druid/IntervalObservable';

export const interval = IntervalObservable.create;